const axios = require('axios');

// export const api = axios.create({ baseURL: 'https://zxi4gxhng.herokuapp.com' });
export const api = axios.create({ baseURL: 'https://tutor-online-api.herokuapp.com' });
